<template>
    <div class="common_monitor">
        <el-form
            label-width="60px"
            :inline="true"
            :model="searchForm"
            class="leader-style-form"
        >
            <el-form-item label="时间">
                <el-date-picker
                    v-model="searchForm.time"
                    type="date"
                    placeholder="选择日期"
                    value-format="yyyy-MM-dd"
                    format="yyyy-MM-dd"
                    :picker-options="disableDate"
                    :clearable="false"
                    :editable="false"
                ></el-date-picker>

                <el-button
                    class="leader-common-button"
                    @click="lastDay"
                    size="medium"
                    >上一日</el-button
                >
                <el-button
                    class="leader-common-button"
                    :disabled="this.sysDate === this.searchForm.time"
                    @click="nextDay"
                    size="medium"
                    >下一日</el-button
                >
                <el-button
                    class="leader-common-button"
                    size="medium"
                    @click="handleSearch"
                    >查询</el-button
                >
            </el-form-item>
        </el-form>
        <div class="common_card_data">
            <div :class="[select_type == 'day' ? 'common_card_item common_card_item_s' : 'common_card_item common_card_item_us']" @click="changeType('day')">
                <div class="common_item_data">
                    <div class="common_item_data_title">
                        {{ current_day }}日太阳辐射度
                    </div>
                    <div class="common_item_data_data">
                        {{ (active_power_day/1000000).toFixed(2) }}
                        <span>MJ/㎡</span>
                    </div>
                </div>
            </div>
            <div :class="[select_type == 'month' ? 'common_card_item common_card_item_s' : 'common_card_item common_card_item_us']" @click="changeType('month')">
                <div class="common_item_data">
                    <div class="common_item_data_title">
                        {{ current_month }}月太阳辐射度
                    </div>
                    <div class="common_item_data_data">
                        {{ (active_power_month/1000000).toFixed(2) }}
                        <span>MJ/㎡</span>
                    </div>
                </div>
            </div>
            <div :class="[select_type == 'year' ? 'common_card_item common_card_item_s' : 'common_card_item common_card_item_us']" @click="changeType('year')">
                <div class="common_item_data">
                    <div class="common_item_data_title">
                        {{ current_year }}年太阳辐射度
                    </div>
                    <div class="common_item_data_data">
                        {{ (active_power_year/1000000).toFixed(2) }}
                        <span>MJ/㎡</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="chart_wrap">
            <div style="display: flex;justify-content: space-around">
                <div class="title">
                    <div class="green"></div>
                    分时趋势
                </div>
                <div style="display: flex">
                    <el-button
                        v-if="!showEcharts"
                        class="leader-common-button"
                        @click="showEchartsClick(true)"
                        >图表</el-button
                    >
                    <el-button
                        v-else
                        class="leader-common-button"
                        @click="showEchartsClick(false)"
                        >数据</el-button
                    >
                </div>
            </div>

            <div class="echart_container"
                v-loading="loading"
                element-loading-text="loading"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(0, 0, 0, 0.8)"
                v-if="showEcharts">
                <v-chart :auto-resize="true" :options="yearBar" ref="yearBar" />
            </div>
            <div v-else style="height: 430px">
                <el-scrollbar style="height: 90%">
                    <el-table
                        :data="echartsTableData"
                        class="leader-style-table"
                        style="margin-top: 10px"
                    >
                        <el-table-column
                            label="时间"
                            property="time"
                            align="center"
                        ></el-table-column>

                        <el-table-column
                            label="数据"
                            property="columnData"
                            align="center"
                        ></el-table-column>
                    </el-table>
                </el-scrollbar>
            </div>
        </div>
    </div>
</template>
<script>
import "echarts/lib/chart/bar";
import "echarts/lib/chart/line";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/legend";
import "echarts/lib/component/toolbox";
import "echarts/lib/component/markPoint";
import "echarts/lib/component/dataZoom";
import * as api from "../../../../http/Use_electricity_monitor";
import moment from "moment";
export default {
    props: {
        pointObj: {
            type: Object
        }
    },
    watch: {
        pointObj: {
            handler(newVal) {
                if (this.searchForm.time) {
                    if (this.pointObj.selectTypeId == "0") {
                        this.getCommonInfo();
                    } else {
                        this.getCommonTreeUnitInfo(this.searchForm.time, "3");
                    }
                } else {
                    this.getSysDate();
                }
            },
            deep: true,
            immediate: true
        }
    },
    data() {
        return {
            loading: false,
            searchForm: {
                time: ""
            },
            sysDate: "",
            disableDate: {
                disabledDate: time => {
                    return (
                        time.getTime() >
                        new Date(
                            new Date(this.sysDate).toLocaleDateString()
                        ).getTime()
                    );
                }
            },
            current_day: "",
            current_month: "",
            current_year: "",
            select_type: "day", // 图表显示日，月，还是年 day,month,year
            chart_title: "",
            active_power_day: "",
            dayUnit: "",
            active_power_month: "",
            monthUnit: "",
            active_power_year: "",
            yearUnit: "",
            class_name: "",
            x_list: [],
            y_list: [],
            showEcharts: true,
            echartsTableData: []
        };
    },
    methods: {
        //获取系统时间
        getSysDate() {
            api.getSysDate({}).then(res => {
                if (res && res.error_code === "0") {
                    this.searchForm.time = res.bus_json.sysdate;
                    this.sysDate = res.bus_json.sysdate;
                    const dateSplice = this.searchForm.time.split("-");
                    this.current_year = dateSplice[0];
                    this.current_month = dateSplice[1];
                    this.current_day = dateSplice[2];
                    this.chart_title = `${this.current_day}日`;
                    // this.getCommonInfo();
                    if (this.pointObj.selectTypeId == "0") {
                        this.getCommonInfo();
                    } else {
                        this.getCommonTreeUnitInfo(this.searchForm.time, "3");
                    }
                }
            });
        },
        // 切换日月年图表数据
        changeType(type) {
            this.select_type = type;   
            if (type == "day") {
                // 日
                this.chart_title = `${this.current_day}日`;

                if (this.pointObj.selectTypeId == "0") {
                    this.getCommonInfo();
                } else {
                    this.getCommonTreeUnitInfo(this.searchForm.time, "3");
                }
            } else if (type == "month") {
                // 月
                this.chart_title = `${this.current_month}月`;
                if (this.pointObj.selectTypeId == "0") {
                    this.getCommonList(
                        `${this.current_year}-${this.current_month}`
                    );
                } else {
                    this.getCommonTreeUnitInfo(this.searchForm.time, "2");
                }
            } else if (type == "year") {
                // 年
                this.chart_title = `${this.current_year}年`;
                if (this.pointObj.selectTypeId == "0") {
                    this.getCommonList(this.current_year);
                } else {
                    this.getCommonTreeUnitInfo(this.searchForm.time, "1");
                }
            }
        },
        /**
         * @description: 获取量及日图表数据
         */
        getCommonInfo() {
            this.loading = true;
            api.getCommonInfo({
                date: this.searchForm.time,
                point_id: this.pointObj.point_id,
                point_class_id: this.pointObj.point_class_id
            }).then(res => {
                this.class_name = res.bus_json.class_name;
                this.active_power_day = res.bus_json.active_power_day;
                this.dayUnit = res.bus_json.dayUnit;
                this.active_power_month = res.bus_json.active_power_month;
                this.monthUnit = res.bus_json.monthUnit;
                this.active_power_year = res.bus_json.active_power_year;
                this.yearUnit = res.bus_json.yearUnit;
                this.x_list = res.bus_json.hour_list;
                this.y_list = res.bus_json.active_power_list;

                this.echartsTableData = [];
                this.x_list.forEach((item, index) => {
                    this.echartsTableData.push({
                        time: item,
                        columnData: res.bus_json.active_power_list[index]
                    });
                });
                this.loading = false;
            });
        },
        // 获取部门和区域的
        getCommonTreeUnitInfo(time, type) {
            this.loading = true;
            api.getCommonTreeUnitInfo({
                type,
                date: time,
                tree_unit_id: this.pointObj.tree_unit_id,
                point_class_id: this.pointObj.point_class_id
            }).then(res => {
                this.class_name = res.bus_json.class_name;
                this.active_power_day = res.bus_json.active_power_day;
                this.dayUnit = res.bus_json.dayUnit;
                this.active_power_month = res.bus_json.active_power_month;
                this.monthUnit = res.bus_json.monthUnit;
                this.active_power_year = res.bus_json.active_power_year;
                this.yearUnit = res.bus_json.yearUnit;
                this.x_list = res.bus_json.hour_list;
                this.y_list = res.bus_json.active_power_list;

                this.echartsTableData = [];
                this.x_list.forEach((item, index) => {
                    this.echartsTableData.push({
                        time: item,
                        columnData: res.bus_json.active_power_list[index]
                    });
                });
                this.loading = false;
            });
        },
        /**
         * @description: 获取月年的数据
         */
        getCommonList(time) {
            this.loading = true;
            api.getCommonList({
                date: time,
                point_id: this.pointObj.point_id,
                point_class_id: this.pointObj.point_class_id
            }).then(res => {
                if (res && res.error_code == 0) {
                    this.x_list = res.bus_json.time_list;
                    this.y_list = res.bus_json.active_power_list;

                    this.echartsTableData = [];
                    this.x_list.forEach((item, index) => {
                        this.echartsTableData.push({
                            time: item,
                            columnData: res.bus_json.active_power_list[index]
                        });
                    });
                    this.loading = false;
                }
            });
        },
        showEchartsClick(bool) {
            this.showEcharts = bool;
        },
        handleSearch() {
            const dateSplice = this.searchForm.time.split("-");
            this.current_year = dateSplice[0];
            this.current_month = dateSplice[1];
            this.current_day = dateSplice[2];
            if (this.select_type == "day") {
                // 日
                if (this.pointObj.selectTypeId == "0") {
                    this.getCommonInfo();
                } else {
                    this.getCommonTreeUnitInfo(this.searchForm.time, "3");
                }
            } else if (this.select_type == "month") {
                // 月
                if (this.pointObj.selectTypeId == "0") {
                    this.getCommonList(
                        `${this.current_year}-${this.current_month}`
                    );
                } else {
                    this.getCommonTreeUnitInfo(this.searchForm.time, "2");
                }
            } else if (this.select_type == "year") {
                // 年
                if (this.pointObj.selectTypeId == "0") {
                    this.getCommonList(this.current_year);
                } else {
                    this.getCommonTreeUnitInfo(this.searchForm.time, "1");
                }
            }
        },
        //上一日
        lastDay() {
            const now = moment(this.searchForm.time);
            this.searchForm.time = now.subtract(1, "days").format("YYYY-MM-DD");
            const dateSplice = this.searchForm.time.split("-");
            this.current_year = dateSplice[0];
            this.current_month = dateSplice[1];
            this.current_day = dateSplice[2];
            // if (this.select_type == "day") {
            // 日
            if (this.pointObj.selectTypeId == "0") {
                this.getCommonInfo();
            } else {
                this.getCommonTreeUnitInfo(this.searchForm.time, "3");
            }
            // }
            // else if (this.select_type == "month") {
            //     // 月
            //     if (this.pointObj.selectTypeId == "0") {
            //         this.getCommonList(
            //             `${this.current_year}-${this.current_month}`
            //         );
            //     } else {
            //         this.getCommonTreeUnitInfo(
            //             `${this.current_year}-${this.current_month}`
            //         );
            //     }
            // } else if (this.select_type == "year") {
            //     // 年
            //     if (this.pointObj.selectTypeId == "0") {
            //         this.getCommonList(this.current_year);
            //     } else {
            //         this.getCommonTreeUnitInfo(this.current_year);
            //     }
            // }
        },
        // 下一日
        nextDay() {
            const now = moment(this.searchForm.time);
            this.searchForm.time = now.add(1, "days").format("YYYY-MM-DD");

            const dateSplice = this.searchForm.time.split("-");
            this.current_year = dateSplice[0];
            this.current_month = dateSplice[1];
            this.current_day = dateSplice[2];
            // if (this.select_type == "day") {
            // 日
            if (this.pointObj.selectTypeId == "0") {
                this.getCommonInfo();
            } else {
                this.getCommonTreeUnitInfo(this.searchForm.time, "3");
            }
            // }
            // else if (this.select_type == "month") {
            //     // 月
            //     if (this.pointObj.selectTypeId == "0") {
            //         this.getCommonList(
            //             `${this.current_year}-${this.current_month}`
            //         );
            //     } else {
            //         this.getCommonTreeUnitInfo(
            //             `${this.current_year}-${this.current_month}`
            //         );
            //     }
            // } else if (this.select_type == "year") {
            //     // 年
            //     if (this.pointObj.selectTypeId == "0") {
            //         this.getCommonList(this.current_year);
            //     } else {
            //         this.getCommonTreeUnitInfo(this.current_year);
            //     }
            // }
        }
    },
    computed: {
        yearBar() {
            const options = {
                tooltip: {
                    trigger: "axis"
                },
                legend: {
                    data: [this.class_name],
                    textStyle: {
                        color: "#fff"
                    }
                },
                grid: {
                    left: "2%",
                    right: "2%",
                    bottom: "5%",
                    top: "15%",
                    containLabel: true
                },
                calculable: true,
                xAxis: [
                    {
                        type: "category",
                        data: this.x_list,
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: "#fff"
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#fff"
                            }
                        }
                    }
                ],
                yAxis: [
                    {
                        type: "value",
                        name: `单位：${this.dayUnit}`,
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: "#fff"
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#fff"
                            }
                        }
                    }
                ],
                series: [
                    {
                        name: this.class_name,
                        type: "bar",
                        data: this.y_list,
                        itemStyle: {
                            color: "#fe7f66"
                        }
                    }
                ]
            };
            return options;
        }
    }
};
</script>
<style lang="scss">
.common_monitor {
    width: 100%;
    height: 100%;
    box-sizing: border-box;

    .common_card_data {
        display: flex;
        justify-content: space-around;
        width: 100%;
        height: 150px;

        .common_card_item_us {
            background: url(../../../../assets/image/custom/gf_topcard_us.png) no-repeat;
            background-size: 100% 100%;
        }
        .common_card_item_s {
            background: url(../../../../assets/image/custom/gf_topcard_s.png) no-repeat;
            background-size: 100% 100%;
        }
        .common_card_item {
            width: 32%;
            height: 100%;
            box-sizing: border-box;
           // border: 1px solid #56fcff;
           // border-radius: 10px;
            cursor: pointer;

            .common_item_data {
                text-align: center;
                font-size: 16px;
                height: 90px;
                line-height: 90px;

                &_title {
                    color: #56fcff;
                    height: 70px;
                    line-height: 80px;
                }

                &_data {
                    color: #fff;
                    height: 50px;
                    line-height: 50px;
                    font-size: 30px;
                    font-weight: bold;

                    span {
                        font-size: 20px;
                        display: inline-block;
                        margin-left: 15px;
                    }
                }
            }

            .common_item_other {
                height: 60px;
                line-height: 40px;
                color: white;
                text-align: center;
                font-size: 14px;
            }

            .common_item_class {
                display: flex;
                justify-content: space-around;
                box-sizing: border-box;
                width: 100%;
                height: 60px;

                &_item {
                    width: 32%;
                    height: 100%;
                    box-sizing: border-box;
                    border: 1px solid #56fcff;
                    border-radius: 10px;
                    text-align: center;
                    color: white;
                    font-size: 14px;
                }
            }
        }
    }

    .chart_wrap {
        margin-top: px2Rem(20px);

        .title {
            .green {
                height: px2Rem(12px);
                width: px2Rem(5px);
                background: #56fcff;
                margin: px2Rem(10px);
                float: left;
            }

            width: 100%;
            font-size: px2Rem(16px);
            text-align: left;
            line-height: px2Rem(32px);
            height: px2Rem(32px);
            border-bottom: 0px solid #dddddd;
            color: #fff;
        }

        .echart_container {
            width: 100%;
            //   height: calc(100% - px2Rem(265px));
            position: relative;

            .changeBtn {
                position: absolute;
                top: 0;
                right: 20px;
                z-index: 9;
            }

            .echarts {
                width: 100%;
                height: px2Rem(360px);
            }

            .leader-style-table {
                width: calc(100% - 17px);
            }
        }
    }
}
</style>
